import Icon from "./IconBase.js";
const TickIconWhiteMB = (props) => {
  return (
    <Icon width="16" height="16" viewBox="0 0 16 16" {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.99999 1.33331C4.33333 1.33331 1.33333 4.33331 1.33333 7.99998C1.33333 11.6666 4.33333 14.6666 7.99999 14.6666C11.6667 14.6666 14.6667 11.6666 14.6667 7.99998C14.6667 4.33331 11.6667 1.33331 7.99999 1.33331ZM6.66666 11.3333L3.33333 7.99998L4.27333 7.05998L6.66666 9.44665L11.7267 4.38665L12.6667 5.33331L6.66666 11.3333Z"
          fill="white"
        />
      </svg>
    </Icon>
  );
};
export default TickIconWhiteMB;
